import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const styles = (theme) => ({
  progress: {
    margin: 2,
  },
});

function LoadingIndicator(props) {
  const { classes, size = 48 } = props;
  return (
    <CircularProgress
      className={classes.progress}
      color="secondary"
      thickness={2.6}
      size={size}
    />
  );
}

LoadingIndicator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoadingIndicator);
